import * as Solr from "../../../../3x1010/Solr.js";
import PageCommon from "../../../PageCommon.js";

export default class ResultsProvider {
  constructor(qb, type) {
    this.qb = qb;
    this.lastRq = null;
    this.type = type;
    this.lastSortOrder = ResultsProvider.DEFAULT_SORT_ORDER;
    ResultsProvider.that = this;
  }

  reset() {
    this.lastRq = null;
  }

  getRows(params) {
    //debugger;
    PageCommon.that.showPreloader(true);
    let rq;
    if (this.type === ResultsProvider.SEARCH_TYPE_ADVANCED) {
      const query = this.qb.getQuery();
      query._searchType = ResultsProvider.SEARCH_TYPE_ADVANCED;
      rq = {
        action: ResultsProvider.SEARCH_TYPE_ADVANCED,
        collectionName: this.qb.getCollection(),
        query: Solr.QueryWrapper.toJsonObject(query, this.qb.getCollection()),
        options: ResultsProvider.SEARCH_TYPE_ADVANCED_OPTIONS,
      };
      if (this.qb.collectionName !== "ARCHIVI_coll") {
        rq.options.OrderBy = "numero_catalogo_generale_NCTN asc,livello_RVEL asc";
      } else {
        rq.options.OrderBy = "id asc";
      }
      //rq.query.Clauses[0].Compare = "tPHRASE";
      //debugger;
    } else if (this.type === ResultsProvider.SEARCH_TYPE_ONFIELD) {
      const query = this.qb.getQuery();
      query._searchType = ResultsProvider.SEARCH_TYPE_ONFIELD;
      rq = {
        action: ResultsProvider.SEARCH_TYPE_ONFIELD,
        collectionName: this.qb.getCollection(),
        query: query,
        options: ResultsProvider.SEARCH_TYPE_ONFIELD_OPTIONS,
      };
      if (this.qb.collectionName !== "ARCHIVI_coll") {
        rq.options.OrderBy = "numero_catalogo_generale_NCTN asc,livello_RVEL asc";
      } else {
        rq.options.OrderBy = "id asc";
      }
      const deepSearch = JSON.parse(localStorage.getItem("deepSearchPreference")).active;
      if (deepSearch) {
        rq.options.DeepSearch = true;
      } else {
        rq.options.DeepSearch = false;
      }
    } else {
      // if (this.type === ResultsProvider.SEARCH_TYPE_FULLTEXT) {
      const query = this.qb.getQuery();
      query._searchType = ResultsProvider.SEARCH_TYPE_FULLTEXT;
      rq = {
        action: ResultsProvider.SEARCH_TYPE_FULLTEXT,
        collectionName: this.qb.getCollection(),
        query: query,
        options: ResultsProvider.SEARCH_TYPE_FULLTEXT_OPTIONS,
      };
      if (this.qb.collectionName !== "ARCHIVI_coll") {
        rq.options.OrderBy = "numero_catalogo_generale_NCTN asc,livello_RVEL asc";
      } else {
        rq.options.OrderBy = "id asc";
      }
      const deepSearch = JSON.parse(localStorage.getItem("deepSearchPreference")).active;
      if (deepSearch) {
        rq.options.DeepSearch = true;
      } else {
        rq.options.DeepSearch = false;
      }
    }

    //rq.options.OrderBy = "numero_catalogo_generale_NCTN asc,livello_RVEL asc";
    //debugger;
    if (this.lastRq) {
      rq.options.RowStart = this.lastRq.options.RowStart + this.lastRq.options.RowsNum;
      // Cerca di capire l'eventuale ordinamento
      if (params.request.sortModel && params.request.sortModel.length > 0) {
        const sortModel = params.request.sortModel[0];

        if (sortModel.sort) {
          // Assegno il nuovo ordinamento
          rq.options.OrderBy = sortModel.colId + " " + sortModel.sort;

          // In questo caso sovrascrivo il rowStart
          rq.options.RowStart = 0;
        }
      } else {
        //rq.options.OrderBy = "numero_catalogo_generale_NCTN asc,livello_RVEL asc";
        //rq.options.RowStart = 0;
      }
    }
    // Se per caso esisteva un lastRq e il lastRq aveva un ordinamento e ora non c'è più, allora forza di nuovo il rowStart a 0
    if (this.lastRq && this.lastRq.options.OrderBy != ResultsProvider.DEFAULT_SORT_ORDER && params.request.sortModel.length === 0) {
      rq.options.RowStart = 0;
    }
    if (!this.lastRq) {
      rq.options.RowStart = 0;
    }

    if (this.lastSortOrder !== rq.options.OrderBy) {
      rq.options.RowStart = 0;
    }
    this.lastSortOrder = rq.options.OrderBy;

    this.lastRq = rq;
    console.log(rq);
    thatServiceManeger.standardCall("/api/solr/" + rq.action, rq, this.onTrySearchHandler.bind(this, params));
  }

  onTrySearchHandler(params, data) {
    console.log(params);
    console.log(data);

    if (!data) {
      params.fail();
      PageCommon.that.showPreloader(false);
      return;
    }
    if (data.Success) {
      const rows = [];
      for (let x = 0; x < data.Rows.length; x++) {
        let row = {};
        for (let key in data.Rows[x]) {
          row[key] = data.Rows[x][key];
        }
        rows.push(row);
      }
      setTimeout(() => {
        PageCommon.that.showPreloader(false);
        params.success({ rowData: rows, rowCount: data.TotalRows }), 100;
      });
    } else {
      params.fail();
      PageCommon.that.showPreloader(false);
    }
  }
}

ResultsProvider.DEFAULT_ROWS_REQUESTED_TO_SERVER = 100;
//ResultsProvider.DEFAULT_SORT_ORDER = "id desc";
ResultsProvider.DEFAULT_SORT_ORDER = "numero_catalogo_generale_NCTN asc,livello_RVEL asc";

ResultsProvider.SEARCH_TYPE_ADVANCED = "advanced";
ResultsProvider.SEARCH_TYPE_FULLTEXT = "fulltext";
ResultsProvider.SEARCH_TYPE_ONFIELD = "onefield";

ResultsProvider.SEARCH_TYPE_FULLTEXT_MODE = "tALLTERMSw"; // meglio questo
ResultsProvider.SEARCH_TYPE_ONFIELD_MODE = "tPHRASEw"; // SBAGLIATO!!!!! va preso in base al tipo di campo (il primo restituito da getOperatorsForType)

// QueryNodeCompareType.tPHRASE = "tPHRASE";
// QueryNodeCompareType.tPHRASEw = "tPHRASEw";
// QueryNodeCompareType.tALLTERMS = "tALLTERMS";
// QueryNodeCompareType.tALLTERMSw = "tALLTERMSw";
// QueryNodeCompareType.tANYTERM = "tANYTERM";
// QueryNodeCompareType.tANYTERMw = "tANYTERMw";
ResultsProvider.SEARCH_TYPE_ADVANCED_OPTIONS = {
  IncludeChilds: true,
  IncludeRelations: 2,
  FilterRelations: null,
  RowStart: 0,
  RowsNum: ResultsProvider.DEFAULT_ROWS_REQUESTED_TO_SERVER,
  OrderBy: ResultsProvider.DEFAULT_SORT_ORDER,
  Fields: "*",
};

ResultsProvider.SEARCH_TYPE_ONFIELD_OPTIONS = {
  IncludeChilds: true,
  IncludeRelations: 2,
  FilterRelations: null,
  RowStart: 0,
  RowsNum: ResultsProvider.DEFAULT_ROWS_REQUESTED_TO_SERVER,
  OrderBy: ResultsProvider.DEFAULT_SORT_ORDER,
  Fields: "*",
};

ResultsProvider.SEARCH_TYPE_FULLTEXT_OPTIONS = {
  IncludeChilds: true,
  IncludeRelations: 2,
  FilterRelations: null,
  RowStart: 0,
  RowsNum: ResultsProvider.DEFAULT_ROWS_REQUESTED_TO_SERVER,
  OrderBy: ResultsProvider.DEFAULT_SORT_ORDER,
  Fields: "*",
  DeepSearch: false,
};
